export const handleFullScreen = (pageRef) => {
    if (pageRef.current) {
        if (document.fullscreenElement) {
            document.exitFullscreen();
        } else {
            pageRef.current.requestFullscreen();
        }
    }
};